import React from 'react';
import PropTypes from 'prop-types';
import { getEEFeature } from './registry';

export function EEFeatureSlot ({ featureKey, fallback = null, render = null }) {
  const Component = getEEFeature(featureKey);

  if (!Component) return fallback ?? null;

  return render ? render(Component) : <Component />;
}

EEFeatureSlot.propTypes = {
  featureKey: PropTypes.string.isRequired,
  fallback: PropTypes.node,
  render: PropTypes.func
};

export default EEFeatureSlot;
